import { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { Card } from "../Home/PainelCards/Card";
import "../Home/PainelCards/Styles.css";
import { initNavigation } from "../../providers/actions";

const mapDispatchToProps = { initNavigation }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const GrandesVolumesHome =
	// redux
	connect(
		(mapStateToProps),
		(mapDispatchToProps)
	)(
		withRouter(
			class extends Component {

				componentDidMount(){
					this.props.initNavigation();
				}

				render() {
					const { user } = this.props;
					let cardsGrandesVolumes = [];

					if (user && user.menu && user.menu.length > 0) {
						const todosSubmenus = [].concat(...user.menu.map(menu => menu.submenus));
						cardsGrandesVolumes = todosSubmenus.filter(submenu => submenu.grupo === "GRANDES_VOLUMES" && Boolean(submenu.card));
					}

					return (
						<Fragment>
							<div style={{margin: "10px"}}>
								<h1>Grandes Volumes</h1>
							</div>

							<div className='home-cards'>
								{cardsGrandesVolumes.map(submenu =>
									<Card key={submenu.id} titulo={submenu.card.titulo} icone={submenu.card.icone} onClick={() => this.props.history.push({pathname: submenu.link, state: { resetSearch: true, backTo: "/grandes-volumes" }})}/>
								)}
							</div>
						</Fragment>
					);
				}
			}
		)
	)
